import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";
import type { SearchHistoryItem } from "@/types";

export function useHistory() {
  return useQuery({
    queryKey: ["searches"],
    queryFn: () => apiFetch<SearchHistoryItem[]>("/api/searches"),
  });
}
